/*
 * Light/dark mode toggle. The initial theme is set by a tiny inline
 * script in <head> (no flash); this handles the toggle button and
 * persists the choice. Only loaded when dark mode is enabled.
 */
(function () {
  var KEY = 'gold:theme';
  function current() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }
  function reflect() {
    var isDark = current() === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-theme-toggle]')) return;
    var next = current() === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem(KEY, next); } catch (err) {}
    reflect();
  });
  reflect();
})();
